var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Box, get, styledTheme, TextBody } from '@ally/metronome-ui';
import React from 'react';
var Border = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  background-color: ", ";\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  ", "\n"], ["\n  border: 1px solid ", ";\n  background-color: ", ";\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  ", "\n"])), get.colors('slate-2'), get.colors('white'), function (_a) {
    var skinny = _a.skinny;
    return "min-height: " + (skinny ? '18px' : '32px');
});
var StatusBar = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var reduceSlant = _a.reduceSlant, completionPercentage = _a.completionPercentage, skinny = _a.skinny;
    return "\n    display: block;\n    width: " + completionPercentage + "%;\n    transition-delay: 1s;\n    position: relative;\n    height: " + (skinny ? '16px' : '30px') + ";\n    transition: width 1.5s ease;\n    &:before {\n      display: block;\n      width: 0;\n      height: 100%;\n      border-bottom: 30px solid #fff;\n      border-left: " + (reduceSlant ? '7px' : '20px') + " solid transparent;\n      position: absolute;\n      top: 0;\n      right: 0;\n      content: '';\n    }\n  ";
});
var StatusBarBackground = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var bgColor = _a.bgColor;
    return "\n    display: block;\n    width: 100%;\n    height: 100%;\n    background-color: " + bgColor + ";\n    transition-delay: 1.5s;\n    transition: background-color 200ms linear;\n  ";
});
var Amount = styled(TextBody)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var isInsideBar = _a.isInsideBar, percentage = _a.percentage;
    return "\n      height: 100%;\n      text-align: " + (isInsideBar ? 'center' : 'left') + ";\n      z-index: 1;\n      position: absolute;\n      top: 5px;\n      left: 0;\n      transition: opacity 0.5s linear;\n      transition-delay: 1s;\n      width: " + percentage + "%;\n      min-width: 20%;\n      margin-left: " + (isInsideBar ? '0' : percentage + "%") + ";\n      padding-left: " + (isInsideBar ? '0' : '5px') + ";\n    ";
});
function AosStkProgressBar(_a) {
    var total = _a.total, _b = _a.percentage, percentage = _b === void 0 ? 0 : _b, _c = _a.actualProgress, actualProgress = _c === void 0 ? 0 : _c, _d = _a.skinny, skinny = _d === void 0 ? false : _d, 
    /* istanbul ignore next */
    _e = _a.barColor, 
    /* istanbul ignore next */
    barColor = _e === void 0 ? 'blueberry' : _e;
    var _f = React.useState(0), delayedPercentage = _f[0], setDelayedPercentage = _f[1];
    var _g = React.useState(0), opacity = _g[0], setOpacity = _g[1];
    var completionPercentage = percentage || Math.floor((actualProgress / total) * 100);
    // handle negative values by converting them to 0
    completionPercentage = completionPercentage < 0 ? 0 : completionPercentage;
    React.useEffect(function () {
        setTimeout(function () {
            setDelayedPercentage(completionPercentage);
            setOpacity(1);
        }, 0);
    }, []);
    var isInsideBar = completionPercentage >= 40;
    var reduceSlant = completionPercentage < 10;
    var incompleteColor = get.colors(barColor)({
        theme: styledTheme,
    });
    var completedColor = get.colors('success')({
        theme: styledTheme,
    });
    return (React.createElement(Border, { p: "none", "data-testid": "stk-progress-bar", skinny: skinny },
        React.createElement(StatusBar, { completionPercentage: delayedPercentage >= 100 ? 110 : delayedPercentage, reduceSlant: reduceSlant, skinny: skinny },
            React.createElement(StatusBarBackground, { bgColor: delayedPercentage < 100 ? incompleteColor : completedColor })),
        !skinny ? (React.createElement(Amount, { tag: "span", size: "sm", weight: "bold", opacity: opacity, color: isInsideBar ? 'white' : 'slate-5', isInsideBar: isInsideBar, percentage: delayedPercentage, "data-testid": "stk-progress-bar-amount" }, delayedPercentage + "%")) : null));
}
export default AosStkProgressBar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map